import { Indicator } from '../../../Common/Charts/Indicator';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';

export const InfantAndFetalMortality = () => {
    const { chartData } = useMortalityMobidityChartsDataContext();

    return (
        <Indicator
            title={'Indice de obitos infantis e fetais'}
            indicatorValue={chartData?.indicators?.infantAndFetalMortality}
            className="aligned-container"
            goalValue={1}
            goalMessage="Meta Aceitável - 10 a cada 1000"
        />
    );
};
